import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME } from '@/features/constants';
import { FiltersGrid, Pagination } from '@/features/types';
import {
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@/features/utils';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const meteringDevicesApi = createApi({
  reducerPath: 'meteringDevicesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/metering-devices`,
  }),
  tagTypes: ['MeteringDevices'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getMeteringDevicesFastIndicatorSubmissionFlow: builder.infiniteQuery<
      {
        contractId: string;
        meteringDeviceId: string;
        commercialMeteringPointId: string;
        commercialMeteringPointName: string;
        meteringDeviceName: string;
        eic: string;
        commercialMeteringPointAddress: string;
        contractNumber: string;
      },
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: `/fast-indicator-submission-flow/query`,
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['MeteringDevices'],
    }),
  }),
});

export const useGetMeteringDevicesFastIndicatorSubmissionFlowInfiniteQuery =
  normalizeInfiniteQueryData(
    meteringDevicesApi.useGetMeteringDevicesFastIndicatorSubmissionFlowInfiniteQuery,
  );
